import {Dialog, Text} from '@di-nxt/components';
import React from 'react';
import {useCallback} from 'react';
import {t} from '../../../localization';
import {ModalProps} from '../../../services';
import {AlertProps} from './types';

export const AlertScreen: React.FC<ModalProps<AlertProps, boolean>> = ({
  title,
  subtitle,
  body,
  okButtonKind,
  okButtonTitle,
  cancelButtonTitle,
  callback,
}) => {
  const handleOk = useCallback(() => callback(true), [callback]);
  const handleCancel = useCallback(() => callback(false), [callback]);

  return (
    <Dialog
      size={'Small'}
      okButtonTitle={okButtonTitle || t('general.ok')}
      okButtonKind={okButtonKind || 'Primary'}
      cancelButtonTitle={cancelButtonTitle || t('general.cancel')}
      title={title}
      subtitle={subtitle}
      onCancelButton={handleCancel}
      onOkButton={handleOk}>
      <Text variant="paragraph_14_default">{body}</Text>
    </Dialog>
  );
};

export * from './task';
